/**
 * ListIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const ListIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      d="M8 13.25A1.75 1.75 0 0 1 9.75 15v4A1.75 1.75 0 0 1 8 20.75H4A1.75 1.75 0 0 1 2.25 19v-4A1.75 1.75 0 0 1 4 13.25zm-4 1.5a.25.25 0 0 0-.25.25v4a.25.25 0 0 0 .25.25h4a.25.25 0 0 0 .25-.25v-4a.25.25 0 0 0-.25-.25z"
      clipRule="evenodd"
    />
    <path d="M18 18.25a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1 0-1.5zm3-4a.75.75 0 0 1 0 1.5h-8a.75.75 0 0 1 0-1.5z" />
    <path
      fillRule="evenodd"
      d="M8 3.25A1.75 1.75 0 0 1 9.75 5v4A1.75 1.75 0 0 1 8 10.75H4A1.75 1.75 0 0 1 2.25 9V5A1.75 1.75 0 0 1 4 3.25zm-4 1.5a.25.25 0 0 0-.25.25v4a.25.25 0 0 0 .25.25h4A.25.25 0 0 0 8.25 9V5A.25.25 0 0 0 8 4.75z"
      clipRule="evenodd"
    />
    <path d="M18 8.25a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1 0-1.5zm3-4a.75.75 0 0 1 0 1.5h-8a.75.75 0 0 1 0-1.5z" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const ListIcon = makeIcon('ListIcon', ListIconSvg)
